import { Routes } from '@angular/router';
import { appUpdateGuard } from './core/guards/app-update.guard';
import { GlobalNotFoundRedirectGuard } from './core/guards/global-not-found-redirect.guard';
import { pageI18nResolver } from './core/resolvers/page-i18n.resolver';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [appUpdateGuard],
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./shared/components/login/login.component').then(
            m => m.LoginComponent
          ),
        resolve: { pageI18n: pageI18nResolver },
        data: { pageI18n: 'login' },
      },
      {
        path: 'register/:token',
        loadComponent: () =>
          import('./organization/register/register.component').then(
            m => m.RegisterComponent
          ),
        resolve: { pageI18n: pageI18nResolver },
        data: { pageI18n: 'register' },
      },
      {
        path: 'setup-account/:token',
        loadComponent: () =>
          import('./organization/setup-account/setup-account.component').then(
            m => m.SetupAccountComponent
          ),
        resolve: { pageI18n: pageI18nResolver },
        data: { pageI18n: 'setup-account' },
      },
      {
        path: 're-activate/:token',
        loadComponent: () =>
          import('./organization/setup-account/setup-account.component').then(
            m => m.SetupAccountComponent
          ),
        resolve: { pageI18n: pageI18nResolver },
        data: { mode: 'reActivate', pageI18n: 're-activate' },
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./shared/components/forgot-password/forgot-password.component').then(
            m => m.ForgotPasswordComponent
          ),
        resolve: { pageI18n: pageI18nResolver },
        data: { userType: 'account', pageI18n: 'forgot-password' },
      },
      {
        path: 'reset-password/:token',
        loadComponent: () =>
          import('./shared/components/reset-password/reset-password.component').then(
            m => m.ResetPasswordComponent
          ),
        resolve: { pageI18n: pageI18nResolver },
        data: { userType: 'account', pageI18n: 'reset-password' },
      },
      /** Public QR scanner page — must stay outside `/organization` layout (no sidenav/header). */
      {
        path: 'engage/:orgAlias',
        loadComponent: () =>
          import('./engage/engage-page.component').then(
            m => m.EngagePageComponent
          ),
        data: { hideLayoutChrome: true },
      },
      {
        path: 'organization',
        loadChildren: () =>
          import('./organization/organization.routes').then(
            m => m.OrganizationRoutes
          ),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('./admin/admin.routes').then(m => m.AdminRoutes),
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: '**',
        canActivate: [GlobalNotFoundRedirectGuard],
        resolve: { pageI18n: pageI18nResolver },
        loadComponent: () =>
          import('./core/page-not-found/page-not-found.component').then(
            m => m.PageNotFoundComponent
          ),
        data: { pageI18n: 'page-not-found' },
      },
    ],
  },
];
